import { EXPERIENCE_CHAPTERS } from "../data/experience";
import { useExperienceStore } from "../store/experience-store";
import { ChapterRail } from "./ChapterRail";
import { ExperienceControls } from "./ExperienceControls";

interface HudProps {
  readonly onChapterSelect: (index: number) => void;
  readonly onToggleAutoPlay: () => void;
}

export function Hud({
  onChapterSelect,
  onToggleAutoPlay,
}: HudProps): React.JSX.Element {
  const chapterIndex = useExperienceStore((store) => store.chapterIndex);
  const autoPlay = useExperienceStore((store) => store.autoPlay);

  return (
    <div className="hud">
      <header className="hud-header">
        <button
          className="brand"
          type="button"
          onClick={() => onChapterSelect(0)}
          aria-label="返回开场"
        >
          <img
            className="brand-wordmark"
            src="./brand/showstrong-white.png"
            alt="先创 SHOWSTRONG"
          />
        </button>
        <div className="system-state">
          <span className="presence presence--on" />
          <span>POINTER MODE</span>
          <span>{autoPlay ? "AUTO" : "LIVE"}</span>
        </div>
      </header>

      <ChapterRail onSelect={onChapterSelect} />

      <div className="hud-footer">
        <ExperienceControls onToggleAutoPlay={onToggleAutoPlay} />
        <span className="chapter-counter">
          {String(chapterIndex).padStart(2, "0")} /{" "}
          {String(EXPERIENCE_CHAPTERS.length - 1).padStart(2, "0")}
        </span>
      </div>
    </div>
  );
}
